// 历史工单
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :dealType="orderDealType"
          :parent-target="_self" :page-type="'历史工单'" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">
            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="soOrderHistoryExport" status="primary" class="button-sty" icon="el-icon-top" @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;position: relative;">
<!--                  <el-input  type="textarea"
                             :autosize="{ minRows: 1, maxRows: 8}"  style="width: 200px;     height: 27px !important; "
                             v-model="formData.orderNoArr" placeholder="请输入工单号或用户联系方式" clearable>
                  </el-input>-->
                  <el-input type="textarea"
                            :autosize="{ minRows: 1, maxRows: 3}" style="width: 200px;     height: 27px !important; " @keyup.enter.native="searchEvent"
                            v-model="formData.orderNoArr" placeholder="请输入工单号" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>

                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;" @click="show3 = !show3">
                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">
                      <path
                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"
                        fill="#0ea2f0" p-id="1588"></path>
                    </svg>
                    <span>更多筛选</span>
                  </div>

                </div>
              </div>
              <el-collapse-transition name="fade">
                <vxe-form v-show="show3" ref="form" class="screen-box" title-width="7vw" title-align="right"
                          :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="工单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orderNo" size="small" clearable style="width:9vw!important;" />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="用户电话:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.userMobile" size="small" clearable style="width:9vw!important;" />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="外部单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.outOrderNo" size="small" clearable style="width:9vw!important;" />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="用户档案:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.profileSearchValue" size="small" style="width:9vw!important;" placeholder="档案号或联系方式" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name">
                    <template v-slot >
                      <el-date-picker style="width: 17vw;" v-model="formData.createDate" type="daterange" align="right"
                                      unlink-panels range-separator="-"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <el-input type="text" autocomplete="off" v-model="formData.bigSiteName" clearable :disabled="isSite" style="width:9vw!important;">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showBigSitePop = true"></i>
                      </el-input>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="下级服务商:" field="name">
                    <template v-slot>
                      <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable :disabled="isSite&&currentSiteData.snSiteInfoDTO.siteFloorLevel == 2" style="width:9vw!important;">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showChangeSite()"></i>
                      </el-input>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="工程师:" field="name">
                    <template v-slot>
                      <el-input type="text" autocomplete="off" v-model="formData.engineerName" clearable style="width:9vw!important;">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showChangeEngineer()"></i>
                      </el-input>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="完工条码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.resultBarcode" size="small" style="width:9vw!important;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="完工时间:" field="name">
                    <template v-slot >
                      <el-date-picker style="width: 17vw;" v-model="formData.completeDate" type="daterange" align="right"
                                      unlink-panels range-separator="-"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="产品大类:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.bigCategoryId" style="width:9vw;" clearable>
                        <el-option v-for="item in bigCategoryOption" :key="item.categoryName"
                                   :label="item.categoryName" :value="item.id" />
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="购买渠道">
                    <template v-slot>
                      <buy-channel-select :buy-channel-id.sync="formData.buyChannelId" style="width:9vw!important;"/>
                    </template>
                  </vxe-form-item>

                </vxe-form>
              </el-collapse-transition>
            </template>

            <template #showSiteComplainStat="{ row }">
              <span class="txt-status " v-if="row.siteComplainStat == 0">无申诉</span>
              <span class="txt-status neutral" v-else-if="row.siteComplainStat == 3">待申诉</span>
              <span class="txt-status " v-else-if="row.siteComplainStat == 5">已申诉</span>
              <span class="txt-status " v-else-if="row.siteComplainStat == 7">中心已审核</span>
              <span class="txt-status disable" v-else-if="row.siteComplainStat == 8">中心驳回</span>
              <span class="txt-status " v-else-if="row.siteComplainStat == 9">总部已处理</span>
              <span class="txt-status disable" v-else-if="row.siteComplainStat == 99">取消</span>
            </template>

            <template #showRecallStat="{ row }">
              <span class="txt-status disable" v-if="row.recallStat == 0">未回访</span>
              <span class="txt-status neutral" v-else-if="row.recallStat == 1">已抽样</span>
              <span class="txt-status " v-else-if="row.recallStat == 2">已回访</span>
              <span class="txt-status " v-else-if="row.recallStat == 5">用户已评价</span>
            </template>

            <template #showStat="{ row }">
              <span class="txt-status " v-if="row.stat == 1">登记</span>
              <span class="txt-status " v-else-if="row.stat == 2">发布</span>
              <span class="txt-status " v-else-if="row.stat == 5">已派网点</span>
              <span class="txt-status " v-else-if="row.stat == 6">网点已接单</span>
              <span class="txt-status " v-else-if="row.stat == 9">已派师傅</span>
              <span class="txt-status " v-else-if="row.stat == 10">师傅已接单</span>
              <span class="txt-status " v-else-if="row.stat == 11">已预约</span>
              <span class="txt-status " v-else-if="row.stat == 13">已出发</span>
              <span class="txt-status " v-else-if="row.stat == 17">已上门</span>
              <span class="txt-status neutral" v-else-if="row.stat == 20">完工暂存</span>
              <span class="txt-status neutral" v-else-if="row.stat == 30">寄修待确认</span>
              <span class="txt-status neutral" v-else-if="row.stat == 31">待寄件</span>
              <span class="txt-status neutral" v-else-if="row.stat == 32">已寄待签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 36">待维修</span>
              <span class="txt-status neutral" v-else-if="row.stat == 37">修好待寄出</span>
              <span class="txt-status neutral" v-else-if="row.stat == 38">客户待签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 40">退换待确认</span>
              <span class="txt-status neutral" v-else-if="row.stat == 41">旧机待退回</span>
              <span class="txt-status neutral" v-else-if="row.stat == 42">旧机待签收</span>
              <span class="txt-status " v-else-if="row.stat == 43">旧机已签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 44">新机待寄出</span>
              <span class="txt-status " v-else-if="row.stat == 45">新机已寄出</span>
              <span class="txt-status neutral" v-else-if="row.stat == 47">新机待签收</span>
              <span class="txt-status " v-else-if="row.stat == 48">新机已签收</span>
              <span class="txt-status disable" v-else-if="row.stat == 49">退换被驳回</span>
              <span class="txt-status " v-else-if="row.stat == 61">已完工</span>
              <span class="txt-status " v-else-if="row.stat == 62">网点确认完工</span>
              <span class="txt-status neutral" v-else-if="row.stat == 63">中心完工审核</span>
              <span class="txt-status neutral" v-else-if="row.stat == 64">总部完工审核</span>
              <span class="txt-status neutral" v-else-if="row.stat == 91">待结算</span>
              <span class="txt-status disable" v-else-if="row.stat == 92">结算驳回</span>
              <span class="txt-status disable" v-else-if="row.stat == 93">结算中止</span>
              <span class="txt-status " v-else-if="row.stat == 94">已结算</span>
              <span class="txt-status disable" v-else-if="row.stat == 97">申请关闭</span>
              <span class="txt-status disable" v-else-if="row.stat == 98">挂起</span>
              <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
              <span class="txt-status disable" v-else-if="row.stat == 100">结束</span>
            </template>

            <template #showGuaranteeType="{ row }">
              <span class="txt-status " v-if="row.guaranteeType == 1">保内</span>
              <span class="txt-status disable" v-else-if="row.guaranteeType == 2">保外</span>
              <span class="txt-status neutral" v-else-if="row.guaranteeType == 3">未知</span>
            </template>


            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
            <template #option="{ row }">
              <div>
                <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id)">
                  <el-tooltip effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                    <i class="el-icon-edit" />
                  </el-tooltip>
                </a>
              </div>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <sitePop v-if="showBigSitePop" :visiable.sync="showBigSitePop" :multi="true" siteFloorLevel="1" @commit="bigSiteCommit"/>

    <sitePop v-if="showSitePop" :visiable.sync="showSitePop" :multi="true" siteFloorLevel="2" :param="param" @commit="siteCommit"/>

    <engineerDialog v-if="showChangeEngineerDialog" :visiable.sync="showChangeEngineerDialog" @commit="engineerCommit" :multi="true" :siteId="querySiteId"/>
  </div>
</template>

<script>
// import editView from './edit.vue';
import editView from './editView.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";

import sitePop from "@/views/dialogCommon/radioSiteDialog.vue"
import engineerDialog from '@/views/dialogCommon/radioEngineerDialog.vue';

import BrandSelect from "@/components/formItem/brandSelect.vue";
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import OrderTypeSelect from "@/components/formItem/orderTypeSelect.vue";
import DispatchStatSelect from "@/components/formItem/dispatchStatSelect.vue";
import store from "@/store";
import { mapState } from 'vuex';
import { indexPageMixins,siteMixins } from "@/mixins/tabChang";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import BuyChannelSelect from "@/components/formItem/buyChannelSelect.vue";

export default {
  mixins: [indexPageMixins,siteMixins],
  inject: ['reload'],
  name: 'historicalWorkOrder',
  components: {
    BuyChannelSelect,
    engineerDialog,
    sitePop,
    DispatchStatSelect,
    OrderTypeSelect,
    ServiceTypeCascader,
    BrandSelect,
    OrgSearch,
    editView,
    pager,
  },

  data() {
    return {
      soOrderHistoryExport: false,
      currentSiteData:{},
      param:{},
      total: 0,
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      orderDealType: "",
      areaObj: null,

      rowData: null,
      showOrderJudgingDialog: false,
      showOrderComplaintHandlingDialog: false,
      showBigSitePop: false,
      showSitePop: false,
      showChangeEngineerDialog: false,
      cancelCheck: false,
      assignAgain: false,
      querySiteId: null,
      requestParam: {
        buyChannelId: null,
        bigCategoryId: null,
        engineerId: null,
        bigSiteId: null,
        engineerValue: null,
        profileSearchValue: null,
        urgeTimesBegin: null,
        urgeTimesEnd: null,
        userAddress: null,
        orderNoArr: null,
        resultBarcode: null,
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        stat: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        searchValue: null,
        tabStat: null,
        managerName: null,
        serviceTypeId: null,
        partsStat: null,
        siteId: null,
        createBy: null,
        bookDateBegin: null,
        bookDateEnd: null,
        orderTypeId: null,
        outOrderNo: null,
        dispatchStat: null,
        areaId: null,
        orgIdPath: null,

        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
      },
      orderRemarkParam: {},
      assignSiteParam: {},
      //批量orderId
      orderIds: [],
      //指派类型0列表指派1批量指派2地图指派3重新指派
      assginType: 0,
      //工单跟进抽屉
      showOrderRemaekDialog: false,
      completionDialog: false,
      bookDialog: false,
      dispatchEngineerDialog: false,
      dispatchedMasterDialog: false,
      subcontractorDialog: false,
      dispatchedNetworkDialog: false,
      //取消审核抽屉
      showCancelCheckDialog: false,
      isSite: null,
      bigCategoryOption: [],
      formData: {
        buyChannelId: null,
        bigCategoryId: null,
        engineerId: null,
        engineerName: '',
        bigSiteName: '',
        bigSiteId: null,
        engineerValue: null,
        profileSearchValue: null,
        urgeTimesBegin: null,
        urgeTimesEnd: null,
        userAddress: null,
        orderNoArr: null,
        resultBarcode: null,
        areaId: null,
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeDate: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        bookDate: null,
        bookDateBegin: null,
        bookDateEnd: null,
        searchValue: null,
        partsStat: null,
        stat: null,
        orderTypeId: null,
        serviceTypeId: null,
        siteId: null,
        createBy: null,
        outOrderNo: null,
        managerName: null,
        siteName: null,
        dispatchStat: null,

        orgId: null,
        orgIdPath: null,
        orgName: null
      },
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      show3: false,
      enableStat: false,
      sitePromptList: [],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,
      showAssignDialog: false,
      showAssignByMapDialog: false,
      showCloseOrderDialog: false,
      orderId: "",
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数
      pageSizes: [10, 20, 100],

      showEdit: false,
      // 指派中心弹框
      showOrgDialog: false,
      columns: [
        { type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left' },
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        {
          title: '工单号', field: 'orderNo', width: 200, slots: {
            default: ({ row }) => {
              return [
                <span style="color: blue"
                  onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        { title: '服务类型', field: 'serviceTypeName', width: 80, },
        { title: '状态', field: 'stat', width: 125, slots: { default: 'showStat' } },
        { title: '用户姓名', field: 'userName', width: 80, },
        { title: '联系方式', field: 'userMobile', width: 120, },
        /*{ title: '品牌', field: 'brandName', width: 100, },*/
        { title: '产品大类', field: 'bigCategoryName', width: 80, },
        { title: '保修类型', field: 'guaranteeType', width: 80, slots: { default: 'showGuaranteeType' } },
        {title: '地区', field: 'userAddress', width: 180,},
        { title: '服务中心', field: 'orgName', width: 100, },
        { title: '服务商', field: 'siteName', width: 100, },
        // { title: '回访状态', field: 'recallStat', width: 125, slots: { default: 'showRecallStat' } },
        { title: '工程师', field: 'engineerName', width: 100, },
        /*{ title: '工单标签', field: 'dispatchStat', width: 80, },*/
        { title: '创建人', field: 'createBy', width: 80, },
        { title: '创建时间', field: 'createTime', width: 150, },
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    // ...mapState(['clickMenu']),

  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {

      if (newVal === 'second') {
        this.orderDealType = ""
        if (this.editViewDataUpdateFlag) {
          this.getTableData()
        }
      }
    },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.completeDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.bookDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.bookDateBegin = newVal[0]
          this.formData.bookDateEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.bookDateBegin = null
          this.formData.bookDateEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
      console.log("当前网点登录信息",this.currentSiteData)
      if(this.currentSiteData.snSiteInfoDTO.siteFloorLevel == 1){
        this.formData.bigSiteName = this.currentSiteData.userName
        this.formData.bigSiteId = this.currentSiteData.id

        console.log("当前登录网点id:"+this.formData.bigSiteId)
        console.log("当前登录网点名称:"+this.formData.bigSiteName)
      }else if(this.currentSiteData.snSiteInfoDTO.siteFloorLevel == 2){
        this.formData.siteName = this.currentSiteData.userName
        this.formData.siteId = this.currentSiteData.id

        console.log("当前登录网点id:"+this.formData.siteId)
        console.log("当前登录网点名称:"+this.formData.siteName)

        this.formData.bigSiteName = this.currentSiteData.snSiteInfoDTO.parentSiteName
        this.formData.bigSiteId = this.currentSiteData.snSiteInfoDTO.parentSiteId
        console.log("当前登录上级网点id:"+this.formData.bigSiteId)
        console.log("当前登录上级网点名称:"+this.formData.bigSiteName)
      }
    }
    console.log("是否为服务商" + this.isSite)
    this.soOrderHistoryExport = this.permissions["soOrderHistoryExport"];//导出
  },

  mounted() {
    this.getTableData()
    this.loadbigCategoryOptions();
  },

  methods: {

    //加载产品大类
    loadbigCategoryOptions() {
      this.$http({
        url: api.basItemCategory.getBigItemCategory,
        method: 'get',
        params: {
          companyId : store.getters.userInfo.tenantId
        }
      }).then(res => {
        this.bigCategoryOption = res.data.data
        console.log("bigCategoryOption",this.bigCategoryOption)
      })
    },

    //导出
    doExcle(){
      this.$objCopy(this.formData, this.requestParam)
      this.$mask.open()
      if(!this.formData.createTimeBegin){
        this.$mask.close()
        this.$message.warning('请选择创建时间，最大为一个月');
        return
      }
      doCheckExcle(fileNames.soOrderHistory).then(response => {
        if (response.data.type=="success"){
          doDownLoadExcle(api.soOrderHistory.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
          this.$mask.close()
        }else{
          this.$mask.close()
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    showChangeSite(){
      console.log("清空上级网点:"+!this.formData.bigSiteName)
      if(!this.formData.bigSiteName){
        this.formData.bigSiteId = null
        this.param.parentSiteId = null
      }
      if(this.formData.bigSiteId){
        this.param.parentSiteId = this.formData.bigSiteId;
      }
      this.showSitePop = true;
    },

    showChangeEngineer(){
      console.log("师傅弹框-------")
      if(!this.formData.siteName){
        this.formData.siteId = null
      }
      if(!this.formData.bigSiteName){
        this.formData.bigSiteId = null
      }
      if(this.formData.bigSiteId){
        this.querySiteId = this.formData.bigSiteId
        console.log("一级网点id:"+this.querySiteId)
      }
      if(this.formData.siteId){
        this.querySiteId = this.formData.siteId
      }
      this.showChangeEngineerDialog = true;
    },

    //师傅弹窗选中
    engineerCommit(row){
      console.log("师傅id:"+row.id)
      this.formData.engineerId = row.id
      this.formData.engineerName = row.engineerName
    },
    // 上级网点弹窗选中
    bigSiteCommit(row) {
      console.log("网点id:"+row.id)
      this.formData.bigSiteId = row.id
      this.formData.bigSiteName = row.name
    },
    siteCommit(row){
      console.log("网点id:"+row.id)
      this.formData.siteId = row.id
      this.formData.siteName = row.name

      this.formData.bigSiteId = row.parentSiteId
      console.log("上级网点id:"+this.formData.bigSiteId)

      this.$http({
        url: api.snUser.getDataUrl,
        method: 'post',
        data: {id:row.parentSiteId}
      }).then(res => {
        console.log("上级网点名称:"+this.formData.bigSiteName)
        this.formData.bigSiteName = res.data.data.userName
      })
    },
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    async getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.soOrderHistory.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },
    closeD(type) {
      this.showCloseOrderDialog = type;
    },

    // 搜索
    searchEvent() {
      if(!this.formData.engineerName){
        this.formData.engineerId = null
      }
      if(!this.formData.siteName){
        this.formData.siteId = null
      }
      if(!this.formData.bigSiteName){
        this.formData.bigSiteId = null
      }
      this.$objCopy(this.formData, this.requestParam)
      console.log("搜索条件:",this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },


    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleAreaChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    addressClickEvent(row, id) {
      this.openEditDialog(row.id);
      console.log(row, id, "row");
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
      this.activeName = 'second';
    },
    // 新增
    openEditDialog(id) {

      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log(this.dataId, '触发了跳转');
    },

    initTableList() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.soOrderHistory.getTableDataUrl,
        param: this.formData,
        method: 'get',


      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);

      this.$refs['table-m1'].commitProxy('reload');
    },


  }
};
</script>
<style lang="scss" scoped>
::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


#avue-view {
  overflow: unset !important;
}
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏



::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}
::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}



::v-deep .el-cascader--medium {
  height: 38px;
}
</style>
